module.exports = __webpack_public_path__ + "static/media/thoughtcast-logo-blue.1023607c.svg";